// /config/util/loadingController.js
let loadingTimer = null
let activeRequests = 0

export default {
  delay: 300,      // 200ms内响应不显示loading
  timeout: 10000,  // 10秒超时强制关闭
  show: null,      // 注入显示loading的方法
  hide: null,       // 注入隐藏loading的方法

  start() {
    //return false // 如果不需要显示loading，可以直接返回false
    if (activeRequests === 0) {
      loadingTimer = setTimeout(() => {
        this.show?.()
      }, this.delay)
    }
    activeRequests++
  },

  stop() {
    // activeRequests = Math.max(0, activeRequests - 1)
    // if (activeRequests === 0) {
    //   clearTimeout(loadingTimer)
    //   this.hide?.()
    // }
    activeRequests--
    if (activeRequests <= 0) {
      activeRequests = 0
      clearTimeout(loadingTimer)
      this.hide?.()
    }
  },

  forceStop() {
    activeRequests = 0
    clearTimeout(loadingTimer)
    this.hide?.()
  }
}